/* HPH share row behavior (PDP + articles). Multiple instances supported. */
(function () {
  function init(root) {
    var url = root.getAttribute('data-share-url');
    var title = root.getAttribute('data-share-title');
    var nativeBtn = root.querySelector('[data-share-native]');
    if (nativeBtn && navigator.share) {
      nativeBtn.hidden = false;
      nativeBtn.addEventListener('click', function () {
        navigator.share({ title: title, url: url }).catch(function () {});
      });
    }
    var copyBtn = root.querySelector('[data-share-copy]');
    var copied = root.querySelector('[data-share-copied]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var done = function () {
          if (!copied) return;
          copied.textContent = 'Link copied';
          setTimeout(function () { copied.textContent = ''; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {});
        }
      });
    }
    root.setAttribute('data-share-ready', 'true');
  }
  function scan() {
    document.querySelectorAll('[data-hph-share]:not([data-share-ready])').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
